/**
 * ============================================================================
 * USER ROLES DEFINITION
 * ============================================================================
 *
 * All user roles in the system.
 * These must match EXACTLY with the roles in your database.
 *
 * NOTE: Route permissions are now in routes.ts
 * ============================================================================
 */

export enum UserRole {
  ADMIN = 'Admin',
  PROGRAM_MANAGER = 'Program Manager',
  ASSESSMENT_CREATOR = 'Assessment Creator',
  HR = 'HR',
  EMPLOYEE = 'Employee',
}

/**
 * Get the default dashboard route for a user role
 */
export const getDefaultRouteForRole = (userRole: string | undefined): string => {
  switch (userRole) {
    case UserRole.ADMIN:
    case UserRole.PROGRAM_MANAGER:
    case UserRole.ASSESSMENT_CREATOR:
    case UserRole.EMPLOYEE:
    case UserRole.HR:
      return '/dashboard';
    default:
      return '/login';
  }
};

/**
 * Check if a role is an admin role (Admin or Program Manager)
 */
export const isAdminRole = (userRole: string | undefined): boolean => {
  return userRole === UserRole.ADMIN || userRole === UserRole.PROGRAM_MANAGER;
};

/**
 * Check if a role is HR
 */
export const isHRRole = (userRole: string | undefined): boolean => {
  return userRole === UserRole.HR;
};
